export default __webpack_public_path__ + "static/media/design-white.99278508.png";